
declare var Object: any;
export interface MyServiceInterface {
  "id"?: string;
}

export class MyService implements MyServiceInterface {
  "id": string;
  constructor(data?: MyServiceInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `MyService`.
   */
  public static getModelName() {
    return "MyService";
  }

  /**
  * This method creates an instance of MyService for dynamic purposes.
  **/
  public static factory(data: MyServiceInterface): MyService{
    return new MyService(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MyService',
      plural: 'MyService',
      path: '/s',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}
